import React from 'react'
import { Modal } from '@telus-uds/components-web'
import PropTypes from 'prop-types'

const ConfirmationModal = ({
  title,
  text,
  cancelButtonText,
  confirmButtonText,
  titleA11yText,
  visible,
  handleCancel,
  handleConfirm,
  handleClose
}) => {
  if (!visible) {
    return null
  }

  return (
    <Modal
      isOpen={visible}
      onClose={handleClose}
      onCancel={handleCancel}
      heading={title}
      bodyText={text}
      confirmButtonText={confirmButtonText}
      onConfirm={handleConfirm}
      cancelButtonText={cancelButtonText}
      aria-label={titleA11yText}
      testID="confirmationModal"
    />
  )
}

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  titleA11yText: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default ConfirmationModal
